import { Banner, Layout, List, Text } from '@shopify/polaris';

/**
 * Aviso de EANs recibidos en la recepción que aún no existen en el catálogo
 * (el SHSTK llegó antes que su SHOPI). Su stock ya está asentado en la cuenta
 * 400; en cuanto se cree el producto se les asignará automáticamente. Se pinta
 * a partir de `unknownEans` que devuelve el endpoint /deliveries/:id/stock.
 */
const UnknownEansNotice = ({ unknownEans }) => {
  if (!unknownEans || unknownEans.length === 0) return null;

  const total = unknownEans.reduce((sum, e) => sum + (e.qtyExpected || 0), 0);

  return (
    <Layout.Section>
      <Banner title="EANs recibidos que aún no están en el catálogo" status="warning">
        <p>
          Estos códigos llegaron en la recepción pero todavía no existen como producto (no se ha procesado su
          catálogo). Su stock está registrado y se asignará automáticamente en cuanto se cree el producto.
        </p>
        <div className="mt-3">
          <List type="bullet">
            {unknownEans.map((e) => (
              <List.Item key={e.barcode}>
                <Text as="span" fontWeight="semibold">
                  {e.barcode}
                </Text>{' '}
                — {e.qtyExpected} uds.
              </List.Item>
            ))}
          </List>
        </div>
        <p className="mt-3">
          {unknownEans.length} {unknownEans.length === 1 ? 'referencia' : 'referencias'}, {total} uds.
        </p>
      </Banner>
    </Layout.Section>
  );
};

export default UnknownEansNotice;
